import type { ElementType, HTMLAttributes } from 'react'
import type { SpacingToken } from '../../styles/tokens'
import { cx } from '../cx'
import styles from './Stack.module.css'

type SpaceStep = Extract<SpacingToken, `space-${string}`>

type StackProps = Omit<HTMLAttributes<HTMLElement>, 'style' | 'className'> & {
  as?:
    | 'div'
    | 'section'
    | 'ul'
    | 'ol'
    | 'li'
    | 'nav'
    | 'header'
    | 'footer'
    | 'main'
    | 'aside'
    | 'article'
    | 'form'
    | 'fieldset'
  gap: SpaceStep
  align?: 'start' | 'center' | 'end' | 'stretch'
  className?: string
}

export function Stack({
  as = 'div',
  gap,
  align,
  className,
  children,
  ...rest
}: StackProps) {
  const Tag: ElementType = as
  return (
    <Tag
      {...rest}
      className={cx(styles.stack, className)}
      data-gap={gap}
      data-align={align}
    >
      {children}
    </Tag>
  )
}
